export default __webpack_public_path__ + "static/web/media/mission.acb77187.jpg";